<template>
    <section
        id="brand-profiles"
        ref="profiles"
        class="profiles"
    >
        <div
            data-wow-delay="0.5s"
            :class="windowWidth <= 768 ? 'wow fadeInUp' : null"
            class="profiles__container"
        >
            <div
                v-for="(profile, index) in profilesSorted"
                :key="profile.ID"
                :class="windowWidth > 768 && showItem ? 'fade-primary' : null"
                :data-wow-delay="windowWidth > 768 && showItem ? index * 0.25 + 's' : null"
                class="profile"
            >
                <div class="profile__image-container">
                    <img
                        :src="profile.image.url"
                        :alt="profile.image.alt"
                        class="profile__image"
                    >
                </div>
                <div class="profile__headings">
                    <h5
                        v-if="profile.year"
                        v-text="profile.year"
                        class="label-subheading profile__date"
                    />
                    <h4
                        v-if="profile.post_title"
                        v-text="profile.post_title"
                        class="heading-05 profile__name"
                    />
                    <hr class="profiles__horizontal-rule">
                </div>
                <p
                    v-if="profile.description"
                    v-text="spliceContent(profile.description)"
                    class="paragraph-02 profile__copy"
                />
                <button
                    @click="activateModal(profile)"
                    v-text="'Learn More'"
                    class="paragraph-01 profile__modal-open"
                />
            </div>
        </div>
        <article
            v-if="modalActive"
            class="base-modal"
            ref="modal"
        >
            <div class="profiles__modal">
                <button class="profile__modal-close" @click="activateModal()">
                    <svg viewBox="0 0 23.213 23.213" aria-hidden="true">
                       <use :xlink:href="themeLink + '/static/graphics/modal-close.svg#modal-close'"></use>
                   </svg>
                </button>
                <div class="profile__modal_headings">
                    <h5 class="label-subheading profile__date" v-text="currentProfile.year"/>
                    <h4 class="heading-02 profile__modal-name" v-text="currentProfile.post_title"/>
                    <h3 class="paragraph-01 profile__modal-title">
                        {{ addComma(currentProfile.award_winners_title) }}
                        <span class="paragraph-01 profile__modal-organization">{{ currentProfile.organization }}</span>
                    </h3>
                    <hr class="profiles__horizontal-rule">
                </div>
                <div class="profile__modal_image-container">
                    <img
                        v-show="currentProfile.image.url"
                        :src="currentProfile.image.url"
                        :alt="currentProfile.image.alt === '' ? 'Photo of ' + currentProfile.post_title : currentProfile.image.alt"
                        class="profile__image"
                    >
                </div>
                <div class="profile__modal-copy_container">
                    <div
                        class="paragraph-02 profile__modal_copy"
                        v-html="currentProfile.description_formatted"
                    />
                    <div class="profile__modal-navigation-container">
                        <button
                            :class="currentProfileIndex === 0 ? 'profile__modal-next-button--disabled' : null"
                            @click="decrementProfile()" class="profile__modal-previous-button"
                        >
                            <svg viewBox="0 0 8.824 15.147" class="profile__modal-svg" aria-hidden="true">
                                <use :xlink:href="themeLink + '/dist/static/graphics/carrot.svg#carrot'"></use>
                            </svg>
                            <p class="profile__modal-navigation-copy" v-text="'Previous'"/>
                        </button>
                        <button
                            :class="currentProfileIndex === profiles.length - 1 ? 'profile__modal-previous-button--disabled' : null"
                            @click="incrementProfile()" class="profile__modal-next-button"
                        >
                            <p class="profile__modal-navigation-copy profile__modal-navigation-secondary" v-text="'Next'"/>
                            <svg viewBox="0 0 8.824 15.147" class="profile__modal-svg profile__modal-svg--rotated" aria-hidden="true">
                                <use :xlink:href="themeLink + '/dist/static/graphics/carrot.svg#carrot'"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </article>
    </section>
</template>

<script>
export default {
    name: 'BrandProfiles',
    props: {
        profiles: {
            type: Array,
            required: true,
        },
        themeLink: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            windowWidth: 0,
            modalActive: false,
            showItem: null,
            nextActive: false,
            previousActive: false,
            currentProfile: undefined,
            currentProfileIndex: undefined,
        };
    },
    /* eslint-disable */
    computed: {
        profilesSorted() {
            return this.profiles.sort(this.sortByYear);
        },
    },
    methods: {
        intersect(entries) {
            const entry = entries.filter(({target}) => {
               return target === this.$refs.profiles;
            });

            if (entry[0].intersectionRatio) {
                 this.showItem = true;
                 return;
            }

            this.showItem = false;
        },
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        addComma(str) {
            return str ? str.concat(',') : str;
        },
        spliceContent(profileDescription) {
            const spliced = profileDescription;
            return spliced
                    .split(' ')
                    .splice(0, 20)
                    .join(' ')
                    .concat('...');
        },
        sortByYear(a, b) {
            if (a.year < b.year) {
                return 1;
            }
            if (a.year > b.year) {
                return -1;
            }

            return 0;
        },
        toggleClass(state, toggledClass) {
            return document.documentElement.classList[state](toggledClass);
        },
        scrollTo(x) {
            return this.$refs.modal.scrollTop = x;
        },
        activateModal(profile) {
            this.showItem = false;
            this.currentProfile = profile;
            this.modalActive = !this.modalActive;

            if (this.modalActive) {
                this.toggleClass('add', 'no-overflow');
                this.toggleClass('add', 'brand-profiles--modal-active');
            } else {
                this.toggleClass('remove', 'no-overflow');
                this.toggleClass('remove', 'brand-profiles--modal-active');
            }
        },
        incrementProfile() {
            this.currentProfile = this.currentProfileIndex < this.profiles.length - 1
                ? this.profiles[this.currentProfileIndex + 1]
                : this.profiles[this.profiles.length - 1];

            this.scrollTo(0);
        },
        decrementProfile() {
            this.currentProfile = this.currentProfileIndex > 0
                ? this.profiles[this.currentProfileIndex - 1]
                : this.profiles[0];

            this.scrollTo(0);
        },
    },
    watch: {
         currentProfile() {
            this.currentProfileIndex = this.profiles.indexOf(this.currentProfile);
        },
    },
    mounted() {
        const io = new IntersectionObserver(
            this.intersect,
            {
                threshold: [this.threshold],
                rootmargin: this.rootmargin,
            },
        )

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.profiles);

        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },
};
</script>



// WEBPACK FOOTER //
// BrandProfiles.vue?14aede57